import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isMetricFilterAppliedSelector } from '@store/trends/base/selectors';
import { useMeasure } from 'react-use';
import {
  ACTION_COL_WIDTH,
  DIMENSION_COL_WIDTH,
  METRIC_COL_WIDTH,
  METRIC_COL_WIDTH_COMPARE,
  SF_COL_WIDTH,
} from '../dimension-table/utils';
import { useDimensionOperations } from './useDimensionOperations';
import { useAtomValue } from 'jotai';
import { isTableCompareEnabledAtom } from '../atoms';

const BUFFER = 20;

// calc width for grid
function useCalcTableWidth() {
  const { dimensionMetrics } = useDimensionOperations();
  const metricFilterApplied = useSelector(isMetricFilterAppliedSelector);
  const isTableCompareEnabled = useAtomValue(isTableCompareEnabledAtom);
  const [ref, { width: parentWidth }] = useMeasure();

  const width = useMemo(() => {
    const mx = metricFilterApplied ? 2 : 0; // metric filter adds two new columns
    const metricColWidth = isTableCompareEnabled ? METRIC_COL_WIDTH_COMPARE : METRIC_COL_WIDTH;
    return Math.min(
      BUFFER +
        ACTION_COL_WIDTH +
        DIMENSION_COL_WIDTH +
        metricColWidth * dimensionMetrics.length +
        mx * SF_COL_WIDTH * dimensionMetrics.length,
      parentWidth,
    );
  }, [dimensionMetrics, metricFilterApplied, isTableCompareEnabled, parentWidth]);

  return { ref, width };
}

export default useCalcTableWidth;
